import getAuthHeaders from "./authHeaders";

export type ArtifactEditMode = 'edit' | 'chat';
export type ArtifactEditAction = 'patch_draft' | 'revise_draft' | 'answer_in_chat' | 'answer_question';
export type ArtifactPatchOperation = 'replace' | 'delete' | 'insert_before' | 'insert_after';

export interface ArtifactEditRequest {
  chatId: string;
  draftText: string;
  selectedText: string;
  beforeContext: string;
  afterContext: string;
  observation: string;
}

export interface ArtifactEditResponse {
  action?: ArtifactEditAction;
  mode?: ArtifactEditMode;
  edits?: Array<{
    operation: ArtifactPatchOperation;
    find: string;
    replace?: string;
    text?: string;
  }>;
  draft?: string;
  replacement?: string;
  answer?: string;
  error?: string;
  _status: number;
}

export default async function fetchArtifactEdit(
  apiAddress: string,
  request: ArtifactEditRequest,
): Promise<ArtifactEditResponse> {
  const response = await fetch(`${apiAddress}/artifact_edit`, {
    method: 'POST',
    headers: await getAuthHeaders({
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify(request),
  });

  const data = await response.json();
  return { ...data, _status: response.status };
}
